// extracted by mini-css-extract-plugin
module.exports = {"GridBlock":"AppCustomization_GridBlock__3p3LW","Grid":"AppCustomization_Grid__372Za"};